/**
 * DynamicText — remplace un texte statique par un texte CMS (dynamic_content).
 * Usage : <DynamicText k="hero_title" fallback="Les Finances Publiques..." />
 */
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const _cache = new Map();

export default function DynamicText({ k, fallback = "", as = "span", lang = "fr", asHtml = false, ...rest }) {
  const [text, setText] = useState(_cache.get(`${k}:${lang}`) ?? fallback);

  useEffect(() => {
    const ck = `${k}:${lang}`;
    if (_cache.has(ck)) { setText(_cache.get(ck)); return; }
    let cancelled = false;
    api.get(`/content/${k}?lang=${lang}`).then(({ data }) => {
      if (cancelled) return;
      const v = data?.data?.content ?? fallback;
      _cache.set(ck, v);
      setText(v);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [k, lang, fallback]);

  const Tag = as;
  if (asHtml) return <Tag dangerouslySetInnerHTML={{ __html: text }} {...rest} />;
  return <Tag {...rest}>{text}</Tag>;
}

export function invalidateDynamicTextCache(k = null, lang = null) {
  if (k && lang) _cache.delete(`${k}:${lang}`);
  else if (k) { for (const key of _cache.keys()) if (key.startsWith(`${k}:`)) _cache.delete(key); }
  else _cache.clear();
}
